import { render, staticRenderFns } from "./dialogCreateTodo.vue?vue&type=template&id=19423033"
import script from "./dialogCreateTodo.vue?vue&type=script&lang=js"
export * from "./dialogCreateTodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports